import { render, staticRenderFns } from "./AreaActionsDropdown.vue?vue&type=template&id=7b96590a&scoped=true&"
import script from "./AreaActionsDropdown.vue?vue&type=script&lang=js&"
export * from "./AreaActionsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96590a",
  null
  
)

export default component.exports